var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "deliverable-block project-block",
      class: {
        "dup-selected": _vm.isSelected,
        "dup-deselected": !_vm.isSelected
      },
      attrs: { id: "dup__deliverable__" + _vm.deliverable.id }
    },
    [
      _c("div", { staticClass: "delv-block-resp" }, [
        _c(
          "div",
          {
            staticClass: "side-box",
            class: {
              "no-border-bottom-left-radius": _vm.expanded && _vm.hasTasks
            }
          },
          [
            _c(
              "button",
              {
                staticClass: "side-box-btn",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toggleSelection.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: { checked: _vm.isSelected },
                    on: { change: _vm.toggleSelection },
                    nativeOn: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.onDuplicateCheckboxClick.apply(
                          null,
                          arguments
                        )
                      }
                    }
                  },
                  [_vm._v("Duplicate")]
                )
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isOrganicSocialMedia
              ? _c(
                  "button",
                  {
                    staticClass: "side-box-btn",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toggleDetailExpand.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.expanded ? "Close" : "Preview"))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isOrganicSocialMedia && _vm.deliverable.posts_count > 0
              ? _c(
                  "button",
                  {
                    staticClass: "side-box-btn",
                    attrs: { disabled: _vm.loadingPosts },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.togglePostSelectionExpand.apply(
                          null,
                          arguments
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.postActionLabel))]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
          _c("div", { staticClass: "dbox-left-side dleft-inner-wrap" }, [
            _c("div", { staticClass: "top-row" }, [
              _c("div", { staticClass: "data-items" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.deliverable.template_title || "Deliverable")
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.deliverable.task_count > 0
                ? _c("div", { staticClass: "data-items hide-mobile" }, [
                    _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.deliverable.task_count) +
                          " " +
                          _vm._s(
                            _vm.deliverable.task_count === 1 ? "TASK" : "TASKS"
                          ) +
                          "\n            "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "data-items hide-mobile" }, [
                _c("span", [_vm._v("CREATED: ")]),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("moment")(
                        _vm.deliverable.created_at,
                        "DD MMM, YYYY"
                      )
                    ) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row listing-row" }, [
              _c("div", { staticClass: "col-md-12 titles" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "deliverable-title edit-d-title dup-deliverable-title"
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.deliverable.title) +
                        "\n              "
                    ),
                    _vm.isOrganicSocialMedia && _vm.deliverable.posts_count > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "dup-title-post-count",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleTitleAction.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-share-alt" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedPostCount) +
                                " / " +
                                _vm._s(_vm.totalPostCount) +
                                " " +
                                _vm._s(_vm.postCountLabel) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.hasTasks && 0
            ? _c("div", { staticClass: "dbox-right-side dright-inner-wrap" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapse-control",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toggleExpand.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "task-exp" }, [
                      !_vm.expanded
                        ? _c("span", [
                            _vm.deliverable.task_count === 1
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.deliverable.task_count)),
                                  _c("br"),
                                  _vm._v(" TASK")
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.deliverable.task_count)),
                                  _c("br"),
                                  _vm._v(" TASKS")
                                ]),
                            _vm._v(" "),
                            _vm._m(0)
                          ])
                        : _c("span", [
                            _c("span", [_vm._v("CLOSE")]),
                            _vm._v(" "),
                            _vm._m(1)
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-exp exp-mobile" }, [
                      !_vm.expanded
                        ? _c("span", [_vm._m(2)])
                        : _c("span", [_vm._m(3)])
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.expanded && _vm.hasTasks && 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 task-list-wrapper" }, [
              _c("div", { staticClass: "side-task-box" }),
              _vm._v(" "),
              _c("div", { staticClass: "task-list-content" }, [
                _c("div", { attrs: { id: "dup__task__field__labels" } }, [
                  _c("div", { staticClass: "field-block d-flex flex-row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "field-control-wrapper field-control-wrapper__title no-radius"
                      },
                      [
                        _c("div", { staticClass: "task-title" }, [
                          _c(
                            "div",
                            { staticClass: "task-table-header__task" },
                            [
                              _vm._v("\n                  Tasks "),
                              _c("span", { staticClass: "task-count-second" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.deliverable.tasks.length) +
                                    ")"
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    false
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__due_date"
                          },
                          [_vm._m(5)]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7)
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "task-fields" },
                  _vm._l(_vm.deliverable.tasks, function(task) {
                    return _c(
                      "div",
                      {
                        key: "dup-task-" + task.id,
                        staticClass: "d-flex flex-row field-block"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "field-control-wrapper field-control-wrapper__title no-radius"
                          },
                          [
                            _c("div", { staticClass: "task-title" }, [
                              _c("div", { staticClass: "field-wrap" }, [
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "field-value",
                                      attrs: { title: task.title }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(task.title) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__user"
                          },
                          [
                            _c("div", { staticClass: "custom-title" }, [
                              _c("div", { staticClass: "field-wrap no-icon" }, [
                                task.user_name
                                  ? _c("span", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(task.user_name))
                                    ])
                                  : _c(
                                      "span",
                                      { staticClass: "field-value text-muted" },
                                      [_vm._v("—")]
                                    )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        false
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__due_date"
                              },
                              [_vm._m(8, true)]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status"
                          },
                          [
                            _c("div", { staticClass: "custom-title" }, [
                              _c("div", { staticClass: "field-wrap no-icon" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "field-value status-field-value",
                                    style: {
                                      backgroundColor:
                                        task.status_color || "#778899"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(task.status_name || "Not Started")
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status_note"
                          },
                          [
                            _c("div", { staticClass: "custom-title" }, [
                              _c("div", { staticClass: "field-wrap no-icon" }, [
                                task.notes
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "field-value dup-notes-value",
                                        attrs: { title: task.notes }
                                      },
                                      [_vm._v(_vm._s(task.notes))]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "field-value text-muted" },
                                      [_vm._v("—")]
                                    )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.expanded && _vm.hasTasks
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 task-list-wrapper" }, [
              _c("div", { staticClass: "side-task-box" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "task-list-content" },
                [
                  _vm.expanded && _vm.activePostDeliverable
                    ? _c("DuplicatePostSelection", {
                        attrs: { deliverable: _vm.activePostDeliverable },
                        on: { close: _vm.closeExpand }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.expanded && _vm.activePreviewDeliverable
                    ? _c("DuplicateDeliverableDetail", {
                        attrs: { deliverable: _vm.activePreviewDeliverable }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/images/chevron-down.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon close-collase" }, [
      _c("img", { attrs: { src: "/images/chevron-up.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/images/chevron-down.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon close-collase" }, [
      _c("img", { attrs: { src: "/images/chevron-up.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__user"
      },
      [
        _c("div", { staticClass: "task-table-header" }, [
          _c("div", { staticClass: "field-label" }, [_vm._v("Assigned to")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "task-table-header" }, [
      _c("div", { staticClass: "field-label" }, [_vm._v("Due Date")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status"
      },
      [
        _c("div", { staticClass: "task-table-header" }, [
          _c("div", { staticClass: "field-label" }, [_vm._v("Status")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status_note"
      },
      [
        _c("div", { staticClass: "task-table-header" }, [
          _c("div", { staticClass: "field-label" }, [_vm._v("Notes")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-title" }, [
      _c("div", { staticClass: "field-wrap no-icon" }, [
        _c("span", { staticClass: "field-value text-muted" }, [
          _vm._v("No Deadline")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }